<template>
  <div class="wrraper">
    <!-- Start Breadcrumb -->
    <Breadcrumb :items="items" />
    <!-- End Breadcrumb -->

    <!-- Start Main Section -->
    <main v-if="data">
      <div>
        <div
          class="why_us_section"
          :class="{ reason_card_ar: $i18n.locale == 'ar' }"
        >
          <div class="container-xl">
            <div class="row align-items-center">
              <div class="col-lg-6 col-sm-12">
                <h6>
                  <!-- {{$t('Subtitle.whyUsSection')}} -->
                  <!-- <span v-for="item in data.slice(0,3)" :key="item.id">
                            {{item.title}}.
                        </span> -->
                </h6>
                <h2>
                  {{ brief.why_us_title_ar }}
                </h2>
                <p>
                  {{ brief.why_us_description_ar }}
                </p>
              </div>
              <div class="col-lg-6 col-sm-12">
                <whyUsCard
                  class="reason_card"
                  v-for="card in data.slice(0, 3)"
                  :key="card.id"
                  :cardData="card"
                  @deleteThis="deleteItem"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
    <!-- End Main Section -->
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title class="text-h5 justify-center">
          {{ $t("table.deletedialog.areYouSure") }}
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#1B5E20" @click="deleteItemConfirm">
            {{ $t("table.deletedialog.ok") }}
          </v-btn>
          <v-btn color="#F44336" @click="dialogDelete = false">
            {{ $t("table.deletedialog.cancel") }}
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: {
    whyUsCard: () => import("@/components/UI/cards/WhyUsCard.vue"),
    // whyUsCard:()=>import('@/components/ui/cards/WhyUsCard.vue')
  },
  data() {
    return {
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.why_us.title"),
          disabled: false,
          href: "/home_page/why_us",
        },
        {
          text: this.$t("breadcrumb.why_us.show"),
          disabled: true,
          href: "",
        },
      ],
      data: null,
      brief: null,
      // ========== dialog Status
      dialogDelete: false,
      dialogDelete_selected: false,
      itemtoDelete: null,

      // ========== Loding
      lodaing: false,
    };
  },

  watch: {},

  computed: {
    ...mapGetters({
      lang: "lang_module/lang",
    }),
  },

  methods: {
    // img Model
    show_model_1(e) {
      this.model_1.model_img_src = e.target.src;
      this.model_1.show_model = true;
    },

    updateSection() {
      this.$router.push({ path: "/home_page/why_us/update" });
    },
    editItems() {
      this.$router.push({ path: "/home_page/why_us/edit" });
    },
    // ===== Delete
    deleteItem(item) {
      this.dialogDelete = true;
      this.itemtoDelete = item;
    },
    deleteItemConfirm() {
      this.axios({
        method: "DELETE",
        url: `home/why_us/features/${this.itemtoDelete.id}`,
      })
        .then(() => {
          this.data = this.data.filter((item) => {
            return item.id != this.itemtoDelete.id;
          });
          this.dialogDelete = false;
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("deleteSuccess"),
            position: "bottomRight",
          });
        })
        .catch((err) => {
          this.dialogDelete = false;
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
        });
    },
    deleteSelected() {
      this.dialogDelete_selected = true;
    },
    // ==================== End CRUD ====================

    // Set Rows
    setRows() {
      this.lodaing = true;
      this.axios({
        method: "GET",
        url: "home/why_us/features",
      })
        .then((res) => {
          this.data = res.data.data;
          this.brief = res.data.brief;
          this.lodaing = false;
        })
        .catch(() => {
          this.lodaing = false;
        });
    },
  },

  // ======= hooks
  mounted() {
    // Set Rows
    this.setRows();
  },
};
</script>
<style lang="scss">
.why_us_section {
  position: relative;
  min-height: 700px;
  h2 {
    @include homeSecondTitle;
    max-width: 380px;
  }
  h6 {
    @include homeFirstTitle;
    span {
      color: inherit;
      font-size: inherit;
      font-family: inherit;
    }
  }
  p {
    font-size: 17px;
    max-width: 400px;
    // font-family: $regular_font;
    color: black;
    line-height: 26px;
  }
  .image_in_background {
    width: 24%;
    max-width: 430px;
    position: absolute;
    bottom: 0px;
    left: 0;
    transform: rotate(10deg);
    z-index: -1;
  }
  .light_button {
    @include lightButton;
    margin-block-start: 25px;
    width: fit-content;
    background: transparent;
    z-index: 8;
    padding-block: 17px;
    * {
      margin-inline-start: 5px;
    }
  }
  .reason_card {
    margin-block-end: 30px;
    // height: 160px;
    p {
      width: 95%;
      max-width: unset;
    }
    img {
      width: 40px;
      height: 40px;
    }
  }
}
.reason_card.text_card_content .inner_card {
  height: 171px !important;
}
</style>
